$(document).on("turbolinks:load", function () {
  let $myModal = $("#passkeyModal")
  let $dismissButtons = $(".js-passkey-modal-dismiss")
  let $overlay = $(".overlay-background")
  let $completed = $myModal.data("completed")
  let $eligible = $myModal.data("eligible")

  // Wait until the feature-announcement modal has been dismissed
  if ($("#alertModal").hasClass("show")) return

  if (!$completed && $eligible) {
    $overlay.css("display", "block")
    $myModal.addClass("show")
    $myModal.css("display", "block")
    $myModal.attr("aria-hidden", false)

    if ($myModal.hasClass("show")) {
      // Re-nudge after 90 days rather than every session
      document.cookie =
        "passkeyModal=completed; path=/; max-age=" + 60 * 60 * 24 * 90

      $dismissButtons.on("click", function () {
        $myModal.removeClass("show")
        $myModal.css("display", "none")
        $myModal.attr("aria-hidden", true)
        $overlay.css("display", "none")
      })
    }
  }
})
